import {MediaCardType} from '@wandb/weave/common/types/media';
import React from 'react';

import AudioCard from '../components/AudioCard';
import BokehCard from '../components/BokehCard';
import HtmlCard from '../components/HtmlCard';
import ImageCard from '../components/ImageCard/ImageCard';
import {MediaCardProps} from '../components/MediaCard';
import MoleculeCard from '../components/MoleculeCard';
import Object3DCard from '../components/Object3DCard';
import PlotlyCard from '../components/PlotlyCard';
import TableCard from '../components/TableCard';
import VideoCard from '../components/VideoCard';

let mediaToComponentMap:
  | {
      [k in MediaCardType]: React.FunctionComponent<MediaCardProps>;
    }
  | undefined;

export const mediaTypeToComponent = (k: MediaCardType) => {
  if (mediaToComponentMap == null) {
    mediaToComponentMap = {
      audio: AudioCard,
      image: ImageCard,
      video: VideoCard,
      table: TableCard,
      plotly: PlotlyCard,
      html: HtmlCard,
      object3D: Object3DCard,
      bokeh: BokehCard,
      molecule: MoleculeCard,
    };
  }
  return mediaToComponentMap[k];
};
